/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1HoldState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_HOLD_STATE_ENTITY_NAME = 'ixc.portfolio.v1.Hold';
export const ixcPortfolioV1HoldStateEntity = new schema.Entity<IxcPortfolioV1HoldState>(IXC_PORTFOLIO_V1_HOLD_STATE_ENTITY_NAME, {}, { idAttribute: 'holdId' });

